import { ImageName } from "@mcleod/images";
import { AbstractSearchFilterTextboxPanel } from "./AbstractSearchFilterTextboxPanel";
import { ChangeEvent } from "../../../../events/ChangeEvent";
import { TextboxVariant } from "../../../textbox/TextboxVariant";

enum InnerIds {
    TEXTBOX_FILTER = "textboxFilter",
    IMAGE_FILTER = "imageFilter",
}

export class FilterTextboxPanel extends AbstractSearchFilterTextboxPanel {
    override syncInnerComponentIds() {
        this.setInnerComponentId(this.textbox, InnerIds.TEXTBOX_FILTER);
        this.setInnerComponentId(this.image, InnerIds.IMAGE_FILTER);
    }

    protected override createTextbox() {
        super.createTextbox();
        this.textbox.setProps({
            placeholder: "Filter",
            marginBottom: 0,
            clearButtonVisible: this.table.filterClearButtonVisible,
        });
        this.textbox.id = this.createInnerComponentId(InnerIds.TEXTBOX_FILTER);
        this.textbox.addChangeListener((event: ChangeEvent) => this.handleFilterInput(event));
    }

    private handleFilterInput(event: ChangeEvent) {
        this.table.filterValue = event.newValue;
    }

    protected override createImage() {
        super.createImage();
        this.image.setProps({
            name: ImageName.filter,
            color: "#9E9E9E"
        });
        this.image.id = this.createInnerComponentId(InnerIds.IMAGE_FILTER);
    }

    override hide() {
        super.hide();
        this.clearTextbox();
    }

    clearTextbox() {
        this.textbox.clear();
        this.table._clearFilterValueSilently();
    }
}
